exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-detail-table[data-v-58aa4fdb]{width:100%;border-top:1px dotted #ccc;margin-bottom:60px}.order-detail-table dl[data-v-58aa4fdb]{-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding:15px 0 4px;display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:1px dotted #ccc;margin:0}.order-detail-table dt[data-v-58aa4fdb]{padding-top:14px;width:30%}.order-detail-table dd[data-v-58aa4fdb]{width:70%;line-height:3}.order-detail-table .ec-label[data-v-58aa4fdb]{display:inline-block;font-weight:700;margin-bottom:5px}.order-detail-table .ec-required[data-v-58aa4fdb]{margin-left:1em;color:#de5d50;font-size:12px;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58aa4fdb","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/order/OrderDetailTable.vue
// module id = 0Py2
// module chunks = 1